"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgLaptop = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#D9EAF5", stroke: "#58627D", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M28 19V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v13z" }),
    React.createElement("path", { fill: "#58627D", d: "m30.828 25.188.914-.406-.005-.01zM29 28v-1zM3 28v-1zm-1.828-2.812-.91-.416-.004.01zM4 19v-1a1 1 0 0 0-.91.584zm24 0 .91-.416A1 1 0 0 0 28 18zm1.914 6.594a1 1 0 0 1 .083.485l1.994.158a3 3 0 0 0-.25-1.455zm.083.485a1 1 0 0 1-.158.466l1.677 1.09c.272-.419.435-.9.475-1.398zm-.158.466a1 1 0 0 1-.362.334l.954 1.758a3 3 0 0 0 1.084-1.002zm-.362.334c-.146.08-.31.121-.477.121v2a3 3 0 0 0 1.431-.363zM29 27H3v2h26zM3 27a1 1 0 0 1-.477-.121l-.954 1.758A3 3 0 0 0 3 29zm-.477-.121a1 1 0 0 1-.362-.334l-1.676 1.09a3 3 0 0 0 1.084 1.002zm-.362-.334a1 1 0 0 1-.158-.466l-1.994.158a3 3 0 0 0 .476 1.398zm-.158-.466a1 1 0 0 1 .083-.485l-1.828-.812a3 3 0 0 0-.249 1.455zm.079-.475 2.828-6.188-1.82-.832-2.828 6.188zM4 20h24v-2H4zm23.09-.584 2.829 6.188 1.819-.832-2.828-6.188z" }),
    React.createElement("path", { stroke: "#58627D", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M14 24h4" })));
exports.default = SvgLaptop;
